// extracted by mini-css-extract-plugin
module.exports = {"container":"FormDetail_container__30B9V","bottomComponent":"FormDetail_bottomComponent__3vP-D","btn_primary":"FormDetail_btn_primary__Tkbj4"};